module.exports = __webpack_public_path__ + "img/popup2.0e412289.png";